import { Link } from "@tanstack/react-router";

import { Picture } from "@/components/Picture";
import { SocialButtons } from "@/components/SocialButtons";
import carrot from "@/images/carrot.png?w=500;900;1200&format=avif;webp;jpg&as=picture";
import { cn } from "@/lib/utils";

export function MarketingFooterMinimal({
  showCarrot = true,
}: {
  showCarrot?: boolean;
}) {
  return (
    <div
      className={cn(
        "bg-slate-5 dark:bg-slatedark-5 text-slate-normal",
        "relative",
      )}
    >
      <div
        className={cn(
          "container mx-auto flex flex-col md:flex-row items-center justify-between gap-12 md:gap-16 w-full px-8 pt-12 pb-16 md:py-14 md:px-12",
        )}
      >
        <div className="flex flex-col gap-7 justify-between items-center md:items-start">
          <div className="font-medium uppercase text-sm text-teal-normal">
            Stay in the know
          </div>
          {/* eslint-disable-next-line @eslint-react/dom/no-missing-iframe-sandbox */}
          <iframe
            title="Newsletter signup"
            src="https://embeds.beehiiv.com/829ec176-4471-415a-9513-f949dd1e11d3?slim=true"
            data-test-id="beehiiv-embed"
            height="52"
            style={{
              margin: 0,
              borderRadius: "0px !important",
              backgroundColor: "transparent",
            }}
          />
          <SocialButtons />
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-5 gap-y-12 md:gap-10 text-sm text-slate-dim">
          <div className="flex flex-col gap-4">
            <div className="font-medium uppercase text-sm text-teal-normal">
              Company
            </div>
            <Link className="hover:underline" to="/about">
              About
            </Link>
            <Link className="hover:underline" to="/blog">
              Blog
            </Link>
            <a
              target="_blank"
              rel="noopener noreferrer"
              className="hover:underline"
              href="mailto:admin@graze.social"
            >
              Press
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              className="hover:underline"
              href="mailto:admin@graze.social"
            >
              Contact
            </a>
          </div>
          <div className="flex flex-col gap-4">
            <div className="font-medium uppercase text-sm text-teal-normal">
              Support
            </div>
            <Link
              target="_blank"
              rel="noopener noreferrer"
              className="hover:underline"
              to="/community-guidelines"
            >
              Community Guidelines
            </Link>
            <Link
              className="hover:underline"
              to="/docs/$slug"
              params={{ slug: "intro" }}
            >
              Docs
            </Link>
            <a
              target="_blank"
              rel="noopener noreferrer"
              className="hover:underline"
              href="https://status.graze.social"
            >
              Site Status
            </a>
            <Link className="hover:underline" to="/docs">
              Help Center
            </Link>
            <a
              target="_blank"
              rel="noopener noreferrer"
              className="hover:underline"
              href="https://grazesocial.canny.io/feature-requests"
            >
              Feature Requests
            </a>
          </div>

          <div className="contents md:flex flex-col gap-4 @container">
            <div className="flex flex-col gap-4">
              <div className="font-medium uppercase text-sm text-teal-normal">
                Legal
              </div>
              <Link
                target="_blank"
                className="hover:underline"
                rel="noopener noreferrer"
                to="/privacy-policy"
              >
                Privacy Policy
              </Link>
              <Link
                target="_blank"
                rel="noopener noreferrer"
                className="hover:underline"
                to="/terms-and-conditions"
              >
                Terms & Conditions
              </Link>
            </div>
            {showCarrot && (
              <Picture
                src={carrot}
                alt=""
                className="w-[80cqw] max-w-[140px] h-auto"
                width={330}
                height={169}
              />
            )}
          </div>
        </div>
      </div>
      <div
        className={cn(
          "text-xs text-slate-11 dark:text-slatedark-11 p-4 text-center",
          "absolute bottom-0 left-0 right-0",
        )}
      >
        &copy; {new Date().getFullYear()} Graze.social. All rights reserved.
      </div>
    </div>
  );
}
